import { SaveModRoutes } from '@save/utils';

export const caseCheckRouteConfig = {
  hideAuth: true,

  groups: [
    {
      groupName: 'Case Check',
      i18n: 'routes.caseCheck.group',
      routes: [
        {
          text: 'Case Check',
          i18n: 'routes.caseCheck.findYourCase',
          url: SaveModRoutes.CASE_CHECK,
        },
      ],
    },
  ],
};
